import React, { useState } from "react";
import { Button, Dropdown, DropdownButton, Modal } from "react-bootstrap";
import Spin from "../../common/Spin";
import moment from "moment";
import { DatePicker } from "rsuite";

const PaymentScheduledApprovalModal = ({
  showModal,
  handleModalClose,
  handleSubmit,
  loading,
  id,
  setApprovalDate,
  approvalDate,
}) => {
  const [emailModal, setEmailModal] = useState(false);
  const toggleEmailModal = () => {
    setEmailModal(!emailModal);
  };
  return (
    <>
      <Modal
        size="lg"
        show={showModal}
        onHide={() => {
          handleModalClose();
        }}
        dialogClassName="modal-50w small-popup review-popup small-review"
        aria-labelledby="contained-modal-title-vcenter"
        className="project-section"
        centered
      >
        <Modal.Header closeButton>Payment Scheduled Approval</Modal.Header>
        <Modal.Body>
          <div className="modal-body">
            {loading && <Spin />}
            <div className="paymentNote" style={{ marginBottom: "10px" }}>
              <p className="aba-transaction-date-label">
                <span className="required">*</span>Approval Date
                <div className="apca-info">
                  <DropdownButton className="info-icon" title="">
                    <Dropdown.Item>
                      <p>
                        {/* Select the date on which date you want to make payment
                                    or you already made the payment. */}
                        Select the payment date
                      </p>
                    </Dropdown.Item>
                  </DropdownButton>
                </div>
              </p>
              <DatePicker
                cleanable={false}
                onChange={(e) => {
                  setApprovalDate(moment(e, "DD-MM-YYYY"));
                }}
                format="dd-MM-yyyy"
                value={
                  approvalDate
                    ? String(approvalDate)?.includes("-")
                      ? new Date(
                          String(approvalDate)?.split("-")[2],
                          String(approvalDate)?.split("-")[1] - 1,
                          String(approvalDate)?.split("-")[0]
                        )
                      : new Date(approvalDate)
                    : null
                }
                className="rs-date-body"
                placeholder="Select Date"
                placement="autoVerticalStart"
                style={{
                  width: "162px",
                }}
                disabledDate={(date) => moment(date).isAfter(moment())}
              />
            </div>
            <p>Do you want to approve these payment claims ?</p>
          </div>
          <div className="modal-footer">
            <Button
              type="Button"
              className="btn btn-secondary"
              onClick={() => {
                handleModalClose();
              }}
            >
              Cancel
            </Button>
            <Button
              type="submit"
              className="btn btn-primary"
              data-dismiss="modal"
              onClick={() => {
                toggleEmailModal(id);
              }}
            >
              Yes
            </Button>
          </div>
        </Modal.Body>
      </Modal>
      {emailModal && (
        <Modal
          size="lg"
          show={emailModal}
          onHide={toggleEmailModal}
          dialogClassName="modal-50w small-popup review-popup small-review"
          aria-labelledby="contained-modal-title-vcenter"
          className="project-section"
          centered
        >
          <Modal.Header closeButton>Send Email Confirmation</Modal.Header>
          <Modal.Body>
            {loading && <Spin />}
            <div
              className="content-details"
              style={{ paddingBottom: "10px", paddingTop: "10px" }}
            >
              <p>
                Would you like BuildTrust to send payment schedules via email
                now?
              </p>
            </div>
            <div className="modal-footer">
              <Button
                type="primary"
                htmlType="submit"
                onClick={() => handleSubmit(id, 1)}
              >
                Yes
              </Button>
              <Button
                type="Button"
                className="btn btn-secondary"
                onClick={() => handleSubmit(id, 0)}
              >
                No
              </Button>
              {/* </div> */}
            </div>
          </Modal.Body>
        </Modal>
      )}
    </>
  );
};

export default PaymentScheduledApprovalModal;
